import React, { Fragment, useContext, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { Pagination, Breadcrumb } from "semantic-ui-react";
import { AppBar } from "./appBar";
import { InternacionalResults } from "./interResults";
import { GlobalContext } from "../context/GlobalState";

export const ShowResults = () => {
  const { resultList, ResultsList } = useContext(GlobalContext);
  const [activePag, setActivePag] = useState(1);
  const [redirct, setRedirct] = useState(false);
  const [copyAllData] = useState(resultList);
  const [tPag] = useState(Math.ceil(parseInt(resultList.length) / 5));

  function setResultsByPage(page, all) {
    page = page - 1;
    const pag = all.slice(page * 5, (page + 1) * 5);
    return pag;
  }

  async function changePage(paginaActiva) {
    setActivePag(paginaActiva);
    let showPag = setResultsByPage(paginaActiva, copyAllData);

    ResultsList(showPag);
  }

  useEffect(() => {
    let showPag = setResultsByPage(activePag, resultList);

    ResultsList(showPag);
    // eslint-disable-next-line
  }, []);

  function stps() {
    setRedirct(true);
  }

  return (
    <Fragment>
      {!resultList.length ? <Redirect to="/search" /> : ""}
      <AppBar />
      <Breadcrumb style={{ backgroundColor: "white" }}>
        <Breadcrumb.Section link onClick={() => stps()}>
          OBL Logistics
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right chevron" />
        <Breadcrumb.Section active>Rastreo</Breadcrumb.Section>
      </Breadcrumb>
      {redirct ? <Redirect to="/search" /> : ""}
      <Row style={{ padding: "15px" }}>
        {/* <Col sm="2"  style={{ background: "blue" }}  /> */}
        <Col sm="12" xl="10" style={{ margin: "0 auto" }}  /* style={{ background: "yellow" }} */>
          {resultList.map((e) => {
            return <InternacionalResults element={e} />;
          })}
        </Col>
        {/* <Col sm="2"  style={{ background: "pink" }} > </Col> */}
      </Row>
      <br />
      <Row>
        <div className="col-12">
          <center>
            <Pagination
              activePage={activePag}
              ellipsisItem={null}
              totalPages={tPag}
              onPageChange={(e, { activePage }) => changePage(activePage)}
            />
          </center>
        </div>
      </Row>
    </Fragment>
  );
};
